import React, { useState, useEffect, useRef } from 'react';
import OwnerDashboard from './OwnerDashboard';
import OwnerAnalytics from './OwnerAnalytics';
import OwnerMenuManagement from './OwnerMenuManagement';
import QRTableManagement from './QRTableManagement';
import './ownerApp.css';
import { BarChart2, LayoutGrid, Menu as MenuIcon } from 'lucide-react';

// Shell container for Owner POV similar to QrBillingApp to unify background + footer
export default function OwnerApp({ onSwipeToCoreDashboard, goTo }) {
  // Keep original footer styling; tabs: dashboard | menu | analytics
  const [tab, setTab] = useState('dashboard');
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    document.body.classList.add('owner-app-active');
    return () => document.body.classList.remove('owner-app-active');
  }, []);

  return (
    <div className="owner-theme">
      <div className="owner-shell">
        <div className="owner-content">
          {tab === 'dashboard' && (
            <OwnerDashboard 
              goTo={goTo}
              onModalChange={setModalOpen} 
              onNavigateToMenu={() => setTab('menu')}
              onNavigateToTables={() => setTab('tables')}
              onNavigateToCoreDashboard={onSwipeToCoreDashboard}
            />
          )}
          {tab === 'menu' && <OwnerMenuManagement onBack={() => setTab('dashboard')} goTo={goTo} />}
          {tab === 'tables' && <QRTableManagement onBack={() => setTab('dashboard')} />}
          {tab === 'analytics' && <OwnerAnalytics onBack={() => setTab('dashboard')} />}
        </div>
      </div>
    </div>
  );
}
